export class Utilisateur {

    Cle:number;
    Nom:string;
    Prenom:string;
    Login:string;

  constructor() {}
}
